// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnCollapsibleMenuComponent {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #353d47;
  font-family: "Noto Sans KR";
  height: 48px !important;
}
.UnCollapsibleMenuComponent .titleContainer {
  margin-top: 2px;
  margin-right: 4px;
  margin-left: 4px;
  margin-bottom: 2px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 13px 18px;
  padding-left: 16px;
  border-radius: 8px;
}
.UnCollapsibleMenuComponent .titleImage {
  height: 24px;
  width: 24px;
  display: inline-block;
  position: relative;
  top: 2px;
}
.UnCollapsibleMenuComponent .titleText {
  display: inline-block;
  position: relative;
  left: 5px;
  font-size: 16px;
  font-weight: 500;
  font-family: "Spoqa Han Sans Neo";
}`, "",{"version":3,"sources":["webpack://./src/components/sideNavBar/UnCollapsibleItem/UnCollapsibleMenu.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,2BAAA;EACA,uBAAA;AACJ;AACI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACR;AAEI;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;AAAR;AAGI;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AADR","sourcesContent":[".UnCollapsibleMenuComponent {\n    position: relative;\n    font-size: 14px;\n    font-weight: 500;\n    color: #353d47;\n    font-family: 'Noto Sans KR';  \n    height: 48px!important;\n\n    .titleContainer { \n        margin-top: 2px;\n        margin-right: 4px;\n        margin-left: 4px;\n        margin-bottom: 2px;\n        cursor: pointer;\n        display: flex;\n        justify-content: space-between;\n        padding: 13px 18px;\n        padding-left: 16px;   \n        border-radius: 8px;\n    }\n\n    .titleImage {\n        height: 24px;\n        width: 24px;\n        display: inline-block;\n        position: relative;\n        top: 2px;\n    }\n\n    .titleText {\n        display: inline-block;\n        position: relative;\n        left: 5px;\n        font-size: 16px;\n        font-weight: 500;\n        font-family: 'Spoqa Han Sans Neo';\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
